import styled from "styled-components";
import { Row, Select } from "antd";

export const StyledSteps = styled.div`
	background: #fff;
	border-radius: 4px;
	padding: 26px 60px;

	.ant-steps{
		left: 0;
		padding: 0;

		.ant-steps-item-content{
			width: 169px;
			position: relative;
			left: -23px;
			margin-top: 9px;


			.ant-steps-item-title{
				font-size: 14px;
				font-weight: 700;
				line-height: 16px !important;
			}
		}

		.ant-steps-item:nth-child(3){
			.ant-steps-item-content {
				left: -29px;
			}
		}

		.ant-steps-item-icon{
			width: 30px;
			height: 30px;
			display: flex;
			justify-content: center;
			align-items: center;
			.ant-steps-icon{
				position: relative;
				left: 1px;
				top: 0;
				font-weight: 700 !important;
				line-height: 19px;
				text-align: center;
			}
		}

		.ant-steps-item-wait{
			.ant-steps-item-title{
				color: var(--gray-steps) !important;
			}
			.ant-steps-item-icon{
				.ant-steps-icon {
					color: var(--gray-steps) !important;
				}
			}
		}

		.ant-steps-item-finish{
			.ant-steps-item-title{
				color: var(--gray-steps) !important;
			}
			.ant-steps-item-icon{
				background: white;
				border-color: white;
				.ant-steps-icon {
					color: #fff !important;
					position: relative;
					right: 1px;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				
			}
		}

		.ant-steps-item-active{
			.ant-steps-item-title {
				color: var(--primary-color) !important;
			}
		}
	}
`
export const StyledContent = styled.div`
	background: #fff;
	box-shadow: 0 2px 6px rgba(176, 186, 197, 0.600289);
	border-radius: 4px;
	margin-top: 24px;
	margin-bottom: 24px;

	.textDanger {
		color: #FF3B30;
	}

	.header {
		padding: 24px 24px 16px 40px;
		font-size: 20px;
		line-height: 40px;
		border-bottom: 1px solid #C4C8CB;
	}

	.ant-select-selection-placeholder {
		color: #bdbdbe;
	}

	.ant {
		
		&-input::placeholder{
			color:#bdbdbe;
		}

		&-form-item {

			&-required {
				&:before {
					margin-right: 0 !important;
					content: ' ' !important;
				}

				&:after {
					display: inline-block;
					color: #ff4d4f;
					font-size: 16px;
					font-family: Open Sans, serif;
					line-height: 24px;
					content: '*' !important;
				}
			}

			&-label {
				label {
					font-size: 16px !important;
					line-height: 24px !important;
					font-weight: 500;
					color: var(--c-gray);
				}
			}
		}
	}
`

export const StyledStepsButtons = styled(Row)`
	padding-bottom: 32px;
	padding-top: 32px;
	
		.ant{
			&-btn{
				width: auto;
				margin-left: 8px;
				margin-right: 8px;
				color: var(--gray-dark);
				font-weight: 600;
			}
		}
	`

export const StyledSelect = styled(Select)`
  .ant-select{
		
    &-selector, &-focused, &-open{
      border-radius: 8px !important;
			font-size: 15px !important;

      
      &:focus, &:hover{
        border-color: #968cff !important;
      }
      
      &:focus{
        box-shadow: 0 0 0 2px #773DBD !important;
        border-color: #968cff !important;
      }
      
      &:active{
        border-color: #968cff !important;
        box-shadow: 0 0 0 2px #773DBD !important;
      }
    }
    
    &-open{
      border-color: #968cff !important;
      box-shadow: 0 0 0 2px #773DBD !important;
    }
    
    
  }
  
  .ant-select-focused{
    .ant-select-selector{
      border-color: red !important;
      
      &:focus, &:hover{
        border-color: #968cff !important;
      }
      
      &:focus{
        box-shadow: 0 0 0 2px #773DBD !important;
        border-color: #968cff !important;
      }
      
      &:active{
        border-color: #968cff !important;
        box-shadow: 0 0 0 2px #773DBD !important;
      }
    }
  }
`